module.exports = __webpack_public_path__ + "img/06.7325fd05.jpg";